module.exports = __webpack_public_path__ + "assets/a-xueshimao1.048d100a.svg";